import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n";
import { LEGAL_ROUTES } from "@/content";
import { useConsent, setConsent } from "@/consent";

export const CookieBanner = () => {
  const { t } = useLang();
  const consent = useConsent();
  const c = t.cookie;
  return (
    <AnimatePresence>
      {!consent && (
        <motion.div
          role="dialog" aria-live="polite" aria-label={c.title} data-testid="cookie-banner"
          initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed z-[70] bottom-3 inset-x-3 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-[520px] border border-red-700/50 bg-black/90 backdrop-blur-xl shadow-[0_0_40px_rgba(220,38,38,0.25)]"
        >
          <div className="h-[2px] bg-gradient-to-r from-red-900 via-red-600 to-transparent" />
          <div className="p-5 sm:p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center border border-red-700/60 bg-red-950/50"><Cookie className="h-4 w-4 text-red-500" strokeWidth={1.75} /></span>
              <p className="font-display font-bold uppercase text-xl text-white tracking-wide">{c.title}</p>
            </div>
            <p className="mt-4 text-sm text-zinc-300 leading-relaxed" data-testid="cookie-banner-text">
              {c.text}{" "}
              <Link to={LEGAL_ROUTES.cookies} data-testid="cookie-banner-policy-link" className="text-white underline underline-offset-4 decoration-red-600 hover:text-red-400">{c.link}</Link>
            </p>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2">
              <button data-testid="cookie-essential-button" onClick={() => setConsent("essential")} className="clip-btn border border-white/30 hover:border-white text-white transition-colors px-4 py-3 font-mono text-xs uppercase tracking-[0.16em]">{c.essential}</button>
              <button data-testid="cookie-accept-all-button" onClick={() => setConsent("all")} className="clip-btn bg-red-600 hover:bg-red-500 text-white transition-colors px-4 py-3 font-mono text-xs uppercase tracking-[0.16em]">{c.accept}</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
